import { ActiveLensSubscription } from "./ActiveLensSubscription";
import { planMetadata } from "src/services/plans";

export function TeamSubscription() {
  return <ActiveLensSubscription licenseType="team" features={planMetadata.team.features} />;
}
